export default {
  page: {
    header: {
      add_employee: 'Add new employee',
      employees: 'Employees',
      users: 'users',
      couriers: 'Couriers',
      area_managers: 'Area managers',
      deputy_managers: 'Deputy Managers',
      admins: 'Admins',
      input_search: 'Search by employee name',
      input_search_route: 'Search by route ID, area',
      input_search_route_name: 'Search by route name',
      routes: 'Routes',
      assign_area_manager: 'Assign area manager',
      payments: 'Payments',
      calendar_setings: 'Calendar setings',
      leaves: 'Leaves',
      complaints: 'Complaints',
      profile: 'Profile',
      work_logs: 'Work logs',
    },
    complaints: {
      deliveries_today: 'Total deliveries today',
      rate_today: 'Total complaints today',
      rate_year: 'Complaint rate today',
    },
    journeys: {
      total_completed: 'Total journeys completed',
      costs_month: 'Costs of',
      total_costs: 'Total costs',
      income_of: 'Income of',
      total_income: 'Total income',
    },
  },
  table: {
    header: {
      name: 'Name',
      id: 'ID',
      email: 'Email address',
      phone: 'Phone',
      area: 'Area',
      status: 'Status',
      supervisor: 'Supervisor',
      date_added: 'Date added',
      last_active: 'Last active',
      from: 'From',
      to: 'To',
      amount_hours: 'Amount of hours',
      number: 'Route Number',
      area_manager: 'Area manager',
      time_planned_seconds: 'Time planned',
      distance: 'Distance',
      date: 'Date',
      type: 'Type',
      employee: 'Employee',
      payout: 'Amount',
      number_route: 'Number of route',
      complaint_rate: 'Complaint rate',
      number_complaints: 'Number of complaints',
      newspapers_delivered: 'Newspapers to be delivered',
      type_employee: 'Type of employee',
      remaining_leave: 'Remaining leave',
      requested_leave: 'Requested leave',
      leave: 'Leave',
      open_requests: 'Open requests',
    },
    pagination: {
      prev_text: 'Previous',
      next_text: 'Next',
    },
    active_text: 'Active',
    no_active_text: 'No active',
    delete_admin: 'Do you wnat to delete admin from system?',
    waiting_uproval: 'Waiting uproval',
    confirmed: 'Confirmed',
    rejected: 'Rejected',
    comment: 'Comment',
  },
  type_group: {
    title: 'Type of employee',
    courier: {
      title: 'Courier',
      text: 'Responsible for creating a new routes and managing own orders',
    },
    area_manager: {
      title: 'Area manager',
      text: 'Responsible for creating a new routes and managing own orders',
    },
    admin: {
      title: 'Admin',
      text: 'Responsible for creating a new routes and managing own orders',
    },
    deputy_area_manager: {
      title: 'Deputy Area Manager',
    },
  },
  status: {
    in_progress: 'In progress',
    waiting_uproval: 'Waiting for approval',
    approved_area_manager: 'Approved by area manager',
    approved_admin: 'Approved by admin',
    rejected: 'Rejected',
    approved_automatically: 'Approved by system',
    cancelled: 'Cancelled by admin',
  },
  info_route: {
    route: 'Route',
    custom: 'Custom',
    amount: 'Amount',
    drived: 'Drived',
    license_plate: 'License plate',
    type_journey: 'Type of journey',
    category: 'Route',
    mileage_exceeded: 'Mileage exceeded',
  },
  holidays: {
    title: 'Holidays',
    add: 'Add holiday',
    date: 'Date',
    name: 'Name',
    year: 'Year',
    empty_title: 'No holidays in the system yet',
    empty_text: 'The new holiday will be applied to the work schedules of all employees'
  }
}
